import { AsyncValidatorFn, FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';

import { Injectable } from '@angular/core';
import { map, debounceTime, tap, take, switchMap, filter } from 'rxjs/operators';
import { DoctorService } from '@nrwl/rx-service-doctor';

@Injectable({
  providedIn: 'root',
})
export class TeamValidatorsService {
  constructor(private doctorService: DoctorService) {}

  /**
   * @TODO remove  changeDetection
   * this parameter was added because otherwise in rx-input always status pending
   */
  public checkEmail(oldEmail: string, changeDetection?): AsyncValidatorFn {
    return (control: FormGroup | any): Observable<{ [key: string]: any } | null> => {
      const email = control.value;

      if (control.pristine) {
        return of(null);
      }

      if (email === oldEmail) {
        return of(null);
      }

      if (email === '') {
        return of(null);
      }

      return control.valueChanges.pipe(
        debounceTime(500),
        take(1),
        filter((value) => !!value),
        switchMap((value: any) => this.doctorService.checkEmail(value)),
        map((data: any) => {
          if (!data.available) {
            return { exists: true };
          }
          return null;
        }),
        tap(() => {
          control.markAsTouched();
          setTimeout(() => {
            if (changeDetection) changeDetection.detectChanges();
          });
        }),
      );
    };
  }

  public checkUsernameUniq(oldUsername: string, changeDetection?): AsyncValidatorFn {
    return (control: any): Observable<{ [key: string]: any } | null> => {
      const username = control.value;

      if (control.pristine) {
        return of(null);
      }

      if (username === oldUsername) {
        return of(null);
      }

      return control.valueChanges.pipe(
        debounceTime(500),
        take(1),
        switchMap((value: any) => this.doctorService.checkUsername(value)),
        map((data: any) => {
          if (!data.available) {
            return { exists: true };
          }
          return null;
        }),
        tap(() => {
          control.markAsTouched();
          setTimeout(() => {
            if (changeDetection) changeDetection.detectChanges();
          });
        }),
      );
    };
  }
}
